import Cookie from "js-cookie";

export const redirectToTryForFree = (event) => {
  if (event) {
    event.preventDefault();
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Trafft signup B 1',
    option: 'B',
    step: '1',
  })

  if(Cookie.get('linkParameters') === undefined) {
    window.open(`${process.env.GATSBY_SIGNUP_URL}?type=free`, '_blank');
  } else {
    window.open(`${process.env.GATSBY_SIGNUP_URL}?type=free&${Cookie.get('linkParameters')}`, '_blank');
  }
}


export const pushToDataLayer = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Trafft signup B 1',
    option: 'B',
    step: '1',
  })
}

export const getRedirectionLink = (lang = 'en') => {
  let signupUrl = process.env.GATSBY_SIGNUP_URL
  if (lang === 'sr') {
    signupUrl = process.env.GATSBY_SIGNUP_URL_SR
  }
  if(Cookie.get('linkParameters') === undefined) {
    return `${signupUrl}?type=free`
  }

  return `${signupUrl}?type=free&${Cookie.get('linkParameters')}`
}

export const redirectToSignupWithPlan = (code, interval) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Trafft signup A 2',
    option: 'A',
    step: '2',
  })

  if(Cookie.get('linkParameters') === undefined) {
    window.location.href = `${process.env.GATSBY_SIGNUP_URL}?plan=${code}&interval=${interval}${Cookie.get('irclickid')}`
  } else {
    window.location.href = `${process.env.GATSBY_SIGNUP_URL}?plan=${code}&interval=${interval}${Cookie.get('irclickid')}&${Cookie.get('linkParameters')}`
  }
}
